var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCouponDownload = function SvgIcCouponDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M.8 14.4c0-.442.326-.8.728-.8h12.944c.402 0 .728.358.728.8s-.326.8-.728.8H1.528c-.402 0-.728-.358-.728-.8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M7.24 2.114a.762.762 0 0 1 1.524 0v9.138a.762.762 0 0 1-1.524 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M3.227 7.241a.76.76 0 0 1 1.077 0L8 10.936l3.695-3.695a.762.762 0 0 1 1.077 1.078l-4.233 4.233a.76.76 0 0 1-1.078 0L3.227 8.32a.76.76 0 0 1 0-1.078",
    clipRule: "evenodd"
  })));
};
export default SvgIcCouponDownload;